<template>
  <div class="bg-card bg-white border-card-border md:px-6">
    <div class="w-full pt-3">
      <div>
        <h1 slot="header" class="text-xl font-semibold pb-2 mt-5">
          Next, we will verify your employment and income.
        </h1>
        <h3 slot="header" class="pb-3 border-b mb-4">
          We work with a company called Pinwheel to verify your employment and income information by
          linking with your payroll account. Click the button below to get verified!
        </h3>
      </div>
      <div class="container md:px-12 pt-16 pb-6 flex flex-col items-center justify-center">
        <h2 v-if="error" class="text-center md:px-20 text-red-600" v-html="subheader" />
        <img v-if="!exitedPinwheel" alt="img" :src="this.image" class="md:w-1/3 my-4" />
        <div class="flex flex-col" style="padding-top: 24px">
          <base-button
            class="items-center m-auto justify-center"
            type="primary ml-auto"
            aria-label="navigate next"
            @click="handleClick"
            :disabled="pinWheelToken === ''"
          >
            {{ this.buttonText }}
          </base-button>
        </div>
        <h2 class="text-center md:px-20 text-black-600">{{ this.underImageText }}</h2>
      </div>
      <!-- Navigation   -->
      <div class="flex w-full mt-4">
        <button
          class="hover:text-primary mr-auto focus:outline-none rounded"
          type="btn"
          aria-label="navigate back"
          v-on:click="handleBack()"
        >
          <i
            class="fas fa-arrow-left bg-gray-300 rounded-full flex items-center text-lg justify-center w-8 h-8"
          ></i>
        </button>

        <base-button
          type="primary ml-auto"
          :loading="nextLoading"
          aria-label="navigate next"
          @click="handleNext()"
          :hidden="!exitedPinwheel"
        >
          Next
        </base-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Pinwheel',
  data: function () {
    return {
      pinwheelLinkToken: '',
      loading: false,
      exitedPinwheel: false,
      nextLoading: false,
      error: false,
      step: 'landing'
    }
  },
  mounted() {
    this.$store.dispatch('initializePinwheel', false)
    if (this.ddSetUp) {
      console.log('true')
      this.step = 'submitted'
    }
  },

  computed: {
    pinWheelToken() {
      return this.$store.state.pinwheelToken
    },
    failText() {
      if (this.$store.state.pinwheelToken === 'FAILURE') {
        return 'We are having trouble connecting to your payroll system at this time. '
      } else {
        return ''
      }
    },
    modalTitle() {
      if (this.$store.state.pinwheelToken === 'FAILURE') {
        return 'Please Call Us!'
      } else {
        return 'Having trouble?'
      }
    },
    buttonText() {
      if (this.exitedPinwheel) {
        return 'Retry'
      }
      return 'Link Payroll'
    },
    subheader() {
      if (this.error) {
        return 'We hit an issue linking with your employer\'s payroll system for verification. No worries, we can verfiy this information another way and you can continue your application by clicking "Next" below! <br><br> Want to try linking with your payroll again? Hit "Retry" below!'
      }
      return ''
    },
    underImageText() {
      return ''
    },
    image() {
      return 'img/sketches/pinwheelIE.svg'
    }
  },
  methods: {
    handleClick() {
      this.pinwheel()
    },
    handleNext() {
      this.$emit('next')
    },
    handleBack() {
      this.globalErrorMessage = ''
      window.scrollTo({ top: 0, behavior: 'smooth' })
      this.$emit('back')
    },
    pinwheel() {
      console.log(this.$store.state.pinwheelToken)
      if (this.$store.state.pinwheelToken === 'FAILURE') {
        this.exitedPinwheel = true
        this.error = false
      } else {
        this.exitedPinwheel = false
        this.error = false
        Pinwheel.open({
          linkToken: this.$store.state.pinwheelToken,
          onSuccess: (result) => {
            this.step = 'submitted'
            console.log('User successfully logged into their payroll portal via pinwheel!')
            console.log('Token ID: ' + result.tokenId)
            this.$store.commit('applicationData/setSuccessfulPinwheelIE', true)
            this.handleNext()
          },
          onExit: (err, result) => {
            console.log('EXIT result: ' + result)

            if (err) {
              console.log('Error code: ' + err.code)
              console.log('Error message: ' + err.message)
              if (err.pendingRetry) {
                this.handleNext()
              }
            }
            this.error = true
            this.exitedPinwheel = true
          },
          onError: (error) => {
            console.log(error)
          },
          onEvent: (eventName, params) => {
            console.log('An event occurred: ', eventName)
            console.log('with params: ', params)
          }
        })
      }
    }
  }
}
</script>
